import { Box, HStack, Heading, Text } from "@chakra-ui/react";
import CustomerSentimentModal from "./CustomerSentimentModal";

const SummaryCard = ({ summary }) => {
  return (
    <Box bg={"white"} borderWidth="1px" p={8} borderRadius={4} mb={8}>
      <HStack>
        <Heading as={"h2"} mt={6} color="#0B3948" size="md" lineHeight={"0"}>
          Customer Sentiment
        </Heading>
        <CustomerSentimentModal />
      </HStack>
      <Text mt={8}>{summary}</Text>
    </Box>
  );
};

export default SummaryCard;
